import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export enum PriceIncreaseType {
    Markup = "Markup",
    Margin = "Margin",
}

export interface RetailModePricingTierModel {
    id: number;
    from: number;
    to: number;
    priceIncreasePercent: number;
}

export interface RetailModeSettingsModel extends BaseModel {
    activated: boolean;
    priceIncreasePercent: number;
    priceIncreaseType: string;
    pricingTiers: Array<RetailModePricingTierModel>;
    tierPricingActivated: boolean;
}

export interface RetailModePricingTierEditingModel {
    id: number;
    from: string;
    to: string;
    priceIncreasePercent: string;
}

export interface RetailModeSettingsEditingModel {
    activated: boolean;
    priceIncreasePercent: string;
    priceIncreaseType: string;
    pricingTiers: Array<RetailModePricingTierEditingModel>;
    tierPricingActivated: boolean;
}
